import React from 'react';
import { useSelector } from 'react-redux';
import { search } from '@debbie/common/dist/util/index.js';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors.js';
import Checkbox from '../../../Checkbox.js';
import MoneyInput from '../../../MoneyInput.js';
import SearchInput from '../../../SearchInput.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const EconomySettings = (props) => {
    const lang = useSelector((s) => s.lang);
    const allUsers = useSelector(selectAllUsers);
    const tenant = useSelector(selectTenant);
    return (React.createElement("div", null,
        props.customizableCourtFee === false && (React.createElement(MoneyInput, { placeholder: lang.documents.paidCourtFee, allowNull: true, value: props.value.courtFee ?? null, onChange: (val) => {
                if (val) {
                    props.onChange({ courtFee: val });
                }
                else {
                    props.onChange({
                        courtFee: undefined,
                    });
                }
            } })),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToCase, checked: props.value.addCourtFeeToCase, onChange: (e) => {
                props.onChange({ addCourtFeeToCase: e.currentTarget.checked });
            } }),
        tenant?.type === TenantType.Agency && (React.createElement(React.Fragment, null,
            React.createElement(Checkbox, { placeholder: lang.documents.addCourtDisbursementToClientBilling, checked: props.value.addCourtDisbursementToClientBilling, onChange: (e) => {
                    props.onChange({
                        addCourtDisbursementToClientBilling: e.currentTarget.checked,
                    });
                } }),
            React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToClientBilling, checked: props.value.addCourtFeeToClientBilling, onChange: (e) => {
                    props.onChange({
                        addCourtFeeToClientBilling: e.currentTarget.checked,
                    });
                } }))),
        React.createElement(Checkbox, { placeholder: lang.documents.sendInfoAboutRequisitionToRes, checked: props.value.sendInfoToEconomyResponsible, onChange: (e) => props.onChange({
                sendInfoToEconomyResponsible: e.currentTarget.checked,
            }) }),
        props.value.sendInfoToEconomyResponsible && (React.createElement(SearchInput, { searchAll: (q) => {
                const res = search(allUsers ?? [], (u) => `${u.firstName} ${u.lastName}`, q, {});
                return res.map((u) => {
                    return {
                        key: u.id,
                        heading: `${u.firstName} ${u.lastName}`,
                        subheading: u.role,
                        returnData: u,
                    };
                });
            }, onSelect: (result) => {
                props.onChange({
                    economyResponsibleUserId: result.id,
                });
                localStorage.setItem('economyResponsibleUserId', result.id || '');
            }, static: (() => {
                const user = allUsers &&
                    allUsers.find((t) => t.id === props.value.economyResponsibleUserId);
                return ((user && `${user.firstName} ${user.lastName}`) ||
                    props.value.economyResponsibleUserId);
            })(), onRemoveStatic: () => {
                props.onChange({
                    economyResponsibleUserId: '',
                });
                localStorage.setItem('economyResponsibleUserId', '');
            }, searchDelay: 0, forceOpen: true, placeholder: lang.documents.responsible }))));
};
export default EconomySettings;
//# sourceMappingURL=EconomySettings.js.map